/**
 * Plaid configuration - uses Gloss API (backend) endpoints.
 * client_id and client_secret are stored on the backend only.
 */

export interface PlaidConfig {
  url: string;
  apiStage: string;
  endpoint: {
    create_token: string;
    exchange_token: string;
    accounts: string;
    balances: string;
    transactions_sync: string;
    initial_sync: string;
    sync_status: string;
    items: string;
    remove_item: string;
    import_complete: string;
  };
}

const plaidConfig = process.env.PLAID as unknown as PlaidConfig;

export function getPlaidConfig(): PlaidConfig {
  return plaidConfig;
}
